import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import clsx from 'clsx';
RadioGroup;
type Option = {
	id: string;
	value: string;
	label: string;
};

type RadioSize = 'sm' | 'md';

interface Props {
	value?: string;
	option: Option;
	defaultValue?: string;
	orientation?: 'horizontal' | 'vertical';
	onChange: (value: string) => void;
	children?: React.ReactNode;
	size?: RadioSize;
	hideRadioButton?: boolean;
	className?: string;
}

export const RadioButtonSingle: React.FC<Props> = ({
	orientation = 'horizontal',
	value,
	defaultValue,
	option,
	children,
	onChange,
	size = 'md',
	className,
	hideRadioButton,
}) => {
	const sizeClasses = {
		sm: 'h-4 w-4',
		md: 'h-6 w-6',
	};
	return (
		<RadioGroup
			defaultValue={defaultValue}
			onValueChange={onChange}
			orientation={orientation}
			className={clsx('', {
				'flex flex-col': orientation === 'vertical',
				className,
			})}
			value={value}
			id="radio-button"
		>
			<div className="flex items-center space-x-2">
				<RadioGroupItem
					size={size}
					hidden={hideRadioButton}
					value={option.value}
					id={option.id}
					className={clsx(
						'bg-gradient-to-b from-[#FFFFFF] to-[#F4F4F9] border-opacity-primary h-6 w-6 mr-2',
						sizeClasses[size]
					)}
				/>

				<label htmlFor={option.value} className="text-black text-base">
					{children ? children : option.label}
				</label>
			</div>
		</RadioGroup>
	);
};
